import { createAction } from "@reduxjs/toolkit";
import { AUTH_ACTION } from "constants/auth";
import { LoginByProjectData } from "types/auth";

export const authActions = {
  doLogin: createAction(`${AUTH_ACTION}/doLogin`),
  doLogout: createAction(`${AUTH_ACTION}/doLogout`),
  checkUserAuthentication: createAction(
    `${AUTH_ACTION}/checkUserAuthentication`,
  ),
  startCountDown: createAction<LoginByProjectData>(
    `${AUTH_ACTION}/startCountDown`,
  ),
  refetchClientData: createAction(`${AUTH_ACTION}/refetchClientData`),
  setPendingClientData: createAction(`${AUTH_ACTION}/setPendingClientData`),
  setEndLoadingClientData: createAction(
    `${AUTH_ACTION}/setEndLoadingClientData`,
  ),
};
